(() => {
  'use strict';
  if (window.MagmaProductShowcase) {
    window.MagmaProductShowcase.refresh(document);
    return;
  }
  const attempts = new WeakMap();
  const images = '[data-mps-section] .mps-image';
  function safeUrl(value) {
    try {
      const url = new URL(value, document.baseURI);
      return !url.username && !url.password && (url.protocol === 'https:' || url.origin === location.origin) ? url.href : null;
    } catch { return null; }
  }
  function recover(image) {
    if (!image.isConnected || !image.matches(images)) return;
    const media = image.closest('.mps-media');
    const title = image.closest('[data-mps-card]')?.querySelector('[data-mps-fallback-title]');
    if (title) title.hidden = false;
    let state = attempts.get(image);
    if (!state) {
      state = { tried: new Set(), finished: false };
      attempts.set(image, state);
    }
    if (state.finished) return;
    state.tried.add(safeUrl(image.currentSrc || image.src));
    image.alt = media.dataset.mpsFallbackAlt || image.alt;
    for (const candidate of [media.dataset.mpsFallback, media.dataset.mpsNeutral]) {
      const url = candidate && safeUrl(candidate);
      if (!url || state.tried.has(url)) continue;
      state.tried.add(url);
      image.removeAttribute('srcset');
      image.classList.add('mps-fallback-image');
      image.src = url;
      return;
    }
    state.finished = true;
    image.hidden = true;
    const namespace = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('viewBox', '0 0 480 360');
    svg.setAttribute('class', 'mps-inline-fallback');
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', image.alt);
    const path = document.createElementNS(namespace, 'path');
    path.setAttribute('d', 'M160 120h160v120H160z M160 214l43-43 31 31 26-20 60 48');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', '#c3c7ca');
    path.setAttribute('stroke-width', '3');
    svg.append(path);
    image.insertAdjacentElement('afterend', svg);
  }
  function refresh(root) {
    for (const image of root.querySelectorAll(images)) if (image.complete && image.naturalWidth === 0) recover(image);
  }
  document.addEventListener('error', event => {
    if (event.target instanceof HTMLImageElement) recover(event.target);
  }, true);
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  window.MagmaProductShowcase = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  else refresh(document);
})();
